import { useMutation, useQueryClient } from '@tanstack/react-query'

import { QUERY_KEYS } from '@/lib/queryKeys'

import { deleteAddress } from '../addressService'
import type { Address } from '../types/Address'

export const useDeleteAddress = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (addressId: string) => deleteAddress(addressId),
    onMutate: async addressId => {
      await queryClient.cancelQueries({ queryKey: [QUERY_KEYS.ADDRESSES] })
      const previousAddresses = queryClient.getQueryData<Address[]>([QUERY_KEYS.ADDRESSES])
      const addressToDelete = previousAddresses?.find(addr => addr.id === addressId)
      queryClient.setQueryData<Address[]>([QUERY_KEYS.ADDRESSES], old => old?.filter(addr => addr.id !== addressId))
      return { previousAddresses, addressToDelete }
    },
    onError: (_error, _addressId, context) => {
      if (context?.previousAddresses) {
        queryClient.setQueryData([QUERY_KEYS.ADDRESSES], context.previousAddresses)
      }
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.ADDRESSES] })
    },
  })
}
